/**
 * Canonical BK SKU for display, joins, and catalog stock.
 * WH* and BK* refer to the same product; prefix indicates order direction only.
 */
export function normalizeBulkSku(sku: string): string {
  const value = (sku || '').trim().toUpperCase()
  if (!value) return ''
  if (value.startsWith('BK')) return value
  if (value.startsWith('WH')) return `BK${value.slice(2)}`
  return value
}
